module.exports = __webpack_public_path__ + "media/images/archive-b31f807e.svg";